import {useGlobalContext} from "../../../../../services/context.service";
import {settingAPI} from "../../../../../services/settingAPI.service";
import {Button, Grid, Typography} from "@mui/material";
import {fnLocalizeFilter} from "../../../../../services/localize.service";
import {handleCreatePublicKey, handleDeletePublicKey} from "../User/utils/local.request.api";
import {useAppDispatch} from "../../../../../hooks/redux";
import {useEffect} from "react";

export default function ApiKey() {
    const {locale} = useGlobalContext();
    const [getPublicKey, {data: data = {publicKey: ''}}] = settingAPI.useLazyFetchPublicApiKeyQuery();
    const dispatch = useAppDispatch();

    useEffect(() => {
        getPublicKey({locale})
    }, [])

    const handleCreateApiKey = async () => {
        await handleCreatePublicKey({locale, dispatch});
        await getPublicKey({locale});
    };

    const handleDeleteApiKey = async () => {
        const res = await handleDeletePublicKey({locale});
        res && await getPublicKey({locale});
    };

    return <Grid item>
        {data.publicKey !== '' && <Typography style={{wordWrap: "break-word"}}>
            <Typography style={{fontWeight: 600}}> {fnLocalizeFilter(locale, '_lang.module.setting.api.titleApi')}</Typography>
            {data.publicKey}
        </Typography>}
        {data.publicKey === '' && <Button

            variant={'contained'}
            sx={{margin: '1rem'}}
            onClick={handleCreateApiKey}
        >
            {fnLocalizeFilter(locale, '_lang.module.common.title.titleCreate')}
        </Button>}

        {data.publicKey !== '' && <Button

            variant={'contained'}
            sx={{margin: '1rem'}}
            onClick={handleDeleteApiKey}
        >
            {fnLocalizeFilter(locale, '_lang.module.common.title.titleDelete')}
        </Button>}

    </Grid>
}
